// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************

export const ACCORDION_TRANSITION_TIMING = '200ms';
export const PANEL_NAVIGATOR_TRANSITION_TIMING = '400ms';
export const CARD_TRANSITION_ANIMATION_TIMING = '200ms';
export const TABS_ACTIVATE_TRANSITION_TIMING = '200ms';
export const NAV_LIST_TRANSITION_ANIMATION_TIMING = '200ms';
export const MICRO_TRANSITION_TIMING = '150ms';
export const EDITABLE_CONTROLS_TRANSITION_TIMING = '250ms';
export const DEFAULT_MODAL_TRANSITION_TIMING = '350ms';
export const SLIDEIN_MODAL_TRANSITION_TIMING = '300ms';
export const PANEL_TRANSITION_TIMING = '150ms';
export const MODAL_BACKGROUND_TRANSITION_TIMING = '100ms';
export const HOVERLAY_TRANSITION_TIMING = '200ms';
export const FLOATING_ALERT_TIMING = '300ms';
export const POPOVER_TRANSITION_TIMING = '200ms';
export const FLOATING_ALERT_DEFAULT_TIMING = '4000ms';
export const TOOLTIP_DELAY = '300ms';
export const TOOLTIP_DELAY_ON_HOLD = '100ms';
export const SORTABLE_LIST_TRANSITION_TIMING = '100ms';